import type { CityConfig } from "../city-template/types";

export const topshamConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Maine CDC Vital Records", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine vital records office in Augusta" },
    { label: "Marriage Licenses — Sagadahoc County Clerk", href: "https://www.sagadahoccountyme.gov/", description: "Sagadahoc County Clerk — marriage license issuance" },
    { label: "Divorce Records — Sagadahoc County Clerk", href: "https://www.sagadahoccountyme.gov/", description: "Sagadahoc County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Topsham",
  state: "Maine",
  stateAbbr: "ME",
  slug: "topsham",
  route: "/cities/topsham",
  title: "Emergency Passport Topsham, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Topsham, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Topsham, Brunswick, Bath, Bowdoinham, and Sagadahoc County. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Topsham, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Topsham and Sagadahoc County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Topsham%20Maine%20historic%20downtown%20and%20shopping%20district%20with%20the%20Androscoggin%20River%20bridge%2C%20mid-coast%20Maine%20suburban%20town%20with%20New%20England%20architecture%20and%20green%20trees%2C%20scenic%20view%20of%20the%20Topsham%20Fair%20Mall%20area%20and%20Route%20196%20corridor%2C%20summer%20afternoon%20light%2C%20professional%20travel%20photography%2C%20wide%20angle%20scenic%20view%20of%20Topsham%20Maine&width=1800&height=700&seq=topsham-me-hero-001&orientation=landscape",
  heroImageAlt: "Topsham Maine historic downtown and Androscoggin River bridge",
  geoPosition: "43.9275;-69.9675",
  geoPlacename: "Topsham, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 120 miles (2 hours) from Topsham, ME",
  },
  nearbyCitiesZips: [
    { name: "Topsham", zips: "04086" },
    { name: "Brunswick", zips: "04011" },
    { name: "Bath", zips: "04530" },
    { name: "Bowdoinham", zips: "04008" },
    { name: "Richmond", zips: "04357" },
    { name: "Lisbon", zips: "04250" },
    { name: "Harpswell", zips: "04079" },
    { name: "Freeport", zips: "04032" },
    { name: "Boothbay", zips: "04537" },
    { name: "Wiscasset", zips: "04578" },
    { name: "Gardiner", zips: "04345" },
    { name: "Augusta", zips: "04330" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Topsham departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Brunswick", route: "/cities/brunswick" },
    { name: "Emergency passport help in Bath", route: "/cities/bath" },
    { name: "Urgent passport services in Gardiner", route: "/cities/gardiner" },
    { name: "Same-day passport help in Freeport", route: "/cities/freeport" },
    { name: "Expedited passport services in Augusta", route: "/cities/augusta-me" },
    { name: "Passport courier services in Portland", route: "/cities/portland-me" },
    { name: "Rush passport help in Lewiston", route: "/cities/lewiston" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Topsham, Maine remotely via secure courier. We do not have a walk-in office in Topsham — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Topsham travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving the greater Topsham and Sagadahoc County area",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Topsham and Sagadahoc County. From the Topsham Fair Mall area and the historic downtown near the Androscoggin River to the quiet neighborhoods of Bowdoinham and Richmond — we help Topsham travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Topsham neighborhoods and nearby towns including Brunswick, Bath, Bowdoinham, Richmond, Lisbon, Harpswell, Freeport, Boothbay, Wiscasset, Gardiner, and Augusta.",
  howItWorksIntro: "Most Topsham travelers complete everything online and ship documents overnight. No need to drive to Boston or Portland. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Topsham sits at the crossroads of Routes 196 and 24, with many commuters working in Brunswick, Bath, or Portland. Residents and tourists often need passports at short notice. Here are the most common mistakes we see from Topsham-area travelers.",
  testimonialsIntro: "Topsham travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Topsham? Here are the most common ones we hear from Sagadahoc County travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Topsham international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Patricia K.",
      location: "Topsham, ME",
      rating: 5,
      text: "Emergency trip to Ireland to visit my sister. Fast Passport Center got my renewal done in 2 days. I shipped from the Topsham area and had my passport back before I could even pack. Incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas R.",
      location: "Brunswick, ME",
      rating: 5,
      text: "Business trip to London with 3 days notice. Fast Passport Center had my emergency passport ready in 24 hours. The whole process was seamless from my Topsham-Brunswick area.",
      service: "Emergency Passport",
    },
    {
      name: "Linda M.",
      location: "Bath, ME",
      rating: 5,
      text: "Lost my passport before a family cruise to the Caribbean. Fast Passport Center handled everything and had my replacement in 3 days. The acceptance clerk visit was at the Bath Post Office.",
      service: "Lost Passport",
    },
    {
      name: "James C.",
      location: "Bowdoinham, ME",
      rating: 5,
      text: "Passport renewal for our daughter's school trip to Montreal. Fast Passport Center helped us navigate the process and got the passport in 5 days. The shipping from our rural address was easy.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "topsham-1",
      name: "Topsham Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Monument Pl",
      city: "Topsham",
      state: "ME",
      zip: "04086",
      phone: "(207) 725-8821",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "In the heart of Topsham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main passport acceptance facility for Topsham. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "topsham-2",
      name: "Brunswick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "31 Pleasant St",
      city: "Brunswick",
      state: "ME",
      zip: "04011",
      phone: "(207) 725-6931",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles from Topsham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment slots. Popular for Topsham and Brunswick residents.",
      icon: "ri-mail-line",
    },
    {
      id: "topsham-3",
      name: "Bath Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25 Front St",
      city: "Bath",
      state: "ME",
      zip: "04530",
      phone: "(207) 443-5531",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Topsham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Sagadahoc County option. Good for Topsham residents near Bath.",
      icon: "ri-mail-line",
    },
    {
      id: "topsham-4",
      name: "Freeport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5 Bow St",
      city: "Freeport",
      state: "ME",
      zip: "04032",
      phone: "(207) 865-4468",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles from Topsham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Topsham residents near the Freeport border.",
      icon: "ri-mail-line",
    },
    {
      id: "topsham-5",
      name: "Topsham Town Office",
      type: "Municipal Passport Acceptance",
      address: "100 Main St",
      city: "Topsham",
      state: "ME",
      zip: "04086",
      phone: "(207) 725-1722",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "In downtown Topsham",
      website: "https://www.topshammaine.com/",
      websiteLabel: "Topsham Town Office",
      notes: "Town clerk services. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "topsham-6",
      name: "Portland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 Forest Ave",
      city: "Portland",
      state: "ME",
      zip: "04101",
      phone: "(207) 871-8387",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles from Topsham",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the region. Most appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local Topsham photo shops may use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Topsham acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Topsham applicants show up with incorrect checks and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Topsham families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Topsham travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location near Topsham." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Topsham address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Topsham, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Topsham in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays.",
    },
    {
      q: "Can I get a same-day passport in Topsham, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option.",
    },
    {
      q: "Where can I get a fast passport renewal in Topsham, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Topsham with no office visit required. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How far is Topsham from the Boston Passport Agency?",
      a: "Topsham is approximately 120 miles from the Boston Passport Agency — about a 2-hour drive. With Fast Passport Center, you avoid that trip entirely.",
    },
    {
      q: "What acceptance facilities are near Topsham, Maine?",
      a: "Options near Topsham include the Topsham Post Office (04086), Brunswick Post Office (04011), Bath Post Office (04530), and Topsham Town Office (04086). The Topsham Post Office on Monument Pl is most convenient.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery.",
    },
    {
      q: "Is Topsham close to Portland Jetport?",
      a: "Yes, Portland International Jetport (PWM) is about 25 miles from Topsham — roughly 30 minutes. It's the closest major airport for Topsham travelers.",
    },
    {
      q: "How much does expedited passport service cost in Topsham?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a quote.",
    },
    {
      q: "What documents do I need for a first-time passport in Topsham?",
      a: "You'll need proof of citizenship, government-issued photo ID, two passport photos, and payment. We provide a complete checklist and review your documents.",
    },
    {
      q: "Can you help with a child's passport in Topsham?",
      a: "Yes. Child passports require both parents (or notarized consent), the child's birth certificate, and both parents' IDs. We walk Topsham families through the process.",
    },
    {
      q: "Is there a UPS Store near Topsham for shipping documents?",
      a: "Yes, there are UPS locations in Brunswick and Freeport. We provide a prepaid overnight label. The Topsham Post Office on Monument Pl also accepts packages.",
    },
    {
      q: "Can I get passport photos taken in Topsham?",
      a: "Yes, CVS and Rite Aid in the Topsham-Brunswick area offer passport photo services. The Walgreens and CVS in Brunswick are also convenient options.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Brunswick", address: "15 Pleasant St, Brunswick, ME 04011", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Brunswick", address: "25 Pleasant St, Brunswick, ME 04011", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Bath", address: "25 Leeman St, Bath, ME 04530", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Bath", address: "55 Leeman St, Bath, ME 04530", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Freeport", address: "5 Bow St, Freeport, ME 04032", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Freeport", address: "30 Main St, Freeport, ME 04032", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Photo Center — Brunswick", address: "12 Lincoln St, Brunswick, ME 04011", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Rite Aid — Brunswick", address: "35 Bath Rd, Brunswick, ME 04011", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "BMV — Brunswick",
      address: "35 Pleasant St, Brunswick, ME 04011",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. 3 miles from Topsham. Online appointment booking available.",
      featured: true,
    },
    {
      name: "BMV — Bath",
      address: "35 Front St, Bath, ME 04530",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Sagadahoc County option. 8 miles from Topsham.",
      featured: false,
    },
    {
      name: "BMV — Portland",
      address: "25 Middlesex St, Portland, ME 04101",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Largest facility in the region. 25 miles from Topsham.",
      featured: false,
    },
    {
      name: "BMV — Augusta",
      address: "29 State House Station, Augusta, ME 04333",
      hours: "Mon–Fri: 8AM–5PM",
      note: "State capital full-service BMV. 45 miles from Topsham.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "25 miles from Topsham (30 min)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport and closest to Topsham. Direct flights to Boston, New York, Chicago, Philadelphia, and seasonal international connections. The best option for Topsham travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "95 miles from Topsham (1.5 hours)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport with direct flights to major hubs. Alternative for Topsham travelers.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "120 miles from Topsham (2 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many Topsham travelers drive to Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};